

import Accounts from "./Accounts";


class User extends Accounts{
    constructor(params) {
      super(params);
    if (params.email && params.email == 'kristie@Brusters.net'){
      console.log(params);
    }
    this.accountLabel = "User";
    this.accountType = "User";
    this.generic = {};
  this.setParameters(params);
    }
  
    setParameters(params){
      for (var prop in params){
          if (params.hasOwnProperty(prop)){
              var method = "set" + prop.charAt(0).toUpperCase() + prop.slice(1);
              if (this[method]){
                  this[method](params[prop]);
              }
              
          }
      }
    }


    setEmail(val){
      this.email = val;
      this.generic.label = val;
      
    }
    setLocations(arr){
      this.locations = arr;
    }
    setShared(arr){
      this.shared =arr;
      this.generic.subTitle = arr.join(",");
    }
    setValue(val){
      this.email = val;
      this.generic.subTitle = val;
      this.generic.label = val;
    }
    setDocumentId(val){
      this.documentId = val;
      this.generic.id = val;
      this.platformId = val;
      this.generic.platformId = val;
    }
    setId(val){
      this._id = val;
      this.generic._id = val;
    }
    setFullName(val){
      this.generic.name = val;
      this.fullName = val;
    }
}

export default User;
  